import { SvgIcon, useTheme } from "@mui/material";

const PlayIcon = ({ color, fontSize }: any) => {

    const theme = useTheme();

    return (
        <SvgIcon sx={{ fontSize: fontSize || 32 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                <path d="M1.41829 17.793C1.22396 17.793 1.03758 17.7158 0.900164 17.5784C0.762747 17.441 0.685547 17.2546 0.685547 17.0603V0.939833C0.685537 0.812495 0.718713 0.687353 0.781802 0.576742C0.844891 0.466131 0.935717 0.373871 1.04533 0.309055C1.15493 0.24424 1.27954 0.209107 1.40686 0.20712C1.53419 0.205134 1.65983 0.236362 1.77141 0.297727L16.4264 8.35795C16.5413 8.42118 16.6372 8.51412 16.704 8.62706C16.7708 8.74001 16.806 8.86881 16.806 9.00003C16.806 9.13124 16.7708 9.26004 16.704 9.37299C16.6372 9.48593 16.5413 9.57887 16.4264 9.64209L1.77141 17.7023C1.66322 17.7618 1.54176 17.793 1.41829 17.793ZM2.15104 2.17884V15.8211L14.5527 9.00006L2.15104 2.17884Z" fill={color || theme.palette.primary.main} />
            </svg>
        </SvgIcon>
    );

};

export default PlayIcon;